<script>
import _ from "lodash";

export default {
  name: "TheAchievementNameAndTypeCardArch",

  props: {
    achievement: Object,
  },

  computed: {
    achievementTypeName() {
      const achievementTypeName = this.achievement.prtf_achievement_type_name;

      if(_.isNil(achievementTypeName)) return "Отсутсвует";
      else return achievementTypeName;
    },

    achievementName() {
      return this.achievement.name
    },
  },

}
</script>

<template>
<div>
  <v-card-title class="text-body-1 pb-1 text-truncate d-block">
    {{achievementTypeName}}
  </v-card-title>
  <v-card-title class="pt-1 font-weight-bold text-truncate d-block">
    {{ achievementName }}
  </v-card-title>
</div>
</template>

<style scoped>

</style>